import { FundRecommendationResponse } from "@rentablo/api/recommender";
import { useSecurityImages } from "@hooks";
import { Investment } from "@rentablo/api/apiv1";

export const useRecommenderImages = (
  recommendations: FundRecommendationResponse[],
  investment?: Investment
) => {
  // `type` is forced to an ALLOWED_TYPES member: useSecurityImages skips
  // anything else, and real fund types (21_fund) would never be fetched.
  const data = recommendations.map((r) => ({
    hasValidIsin: true,
    type: "22_etf",
    isin: r.fund.isin,
    quoteProvider: "ariva",
  }));

  if (investment) {
    data.push({
      hasValidIsin: true,
      type: "22_etf",
      isin: investment.isin ?? "",
      quoteProvider: investment.quote?.quoteProvider ?? "ariva",
    });
  }

  const images = useSecurityImages(data);

  return {
    images,
  };
};
